import { createClient } from '@supabase/supabase-js';
import { sessionAwareFetch } from './authTransport';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const isSupabaseConfigured = Boolean(url && anonKey && !url.includes('YOUR_PROJECT'));

export const supabase = createClient(
  url ?? 'https://configuration-required.invalid',
  anonKey ?? 'configuration-required',
  {
    global: { fetch: sessionAwareFetch(url ?? 'https://configuration-required.invalid') },
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
